
<Card :id="careType" :clickable="true" class="m-8 care-type-card-item w-160 md:w-240 lg:w-160" @click="handleSelect">
  <div class="card-type-card-content">
    <component :is="careTypeDetails[careType].icon" class="mb-8" />
    <span class="mb-8">{{ careTypeDetails[careType].title }}</span>
    <Spinner v-if="selected" />
    <Arrow v-else />
  </div>
</Card>
